var _style, _defs, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#00237C;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#CF142B;}\n\t.st4{fill:none;stroke:#777777;stroke-width:0.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    transform: "matrix(0.8944 -0.4472 0.4472 0.8944 -4.6122 7.4626)",
    cx: 13.5,
    cy: 13.5,
    rx: 11.9,
    ry: 11.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: 1.1,
    className: "st1",
    width: 15.2,
    height: 8.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-0.5,1.1 -4.7,1.1 -4.7,3.6 15.6,17 20.6,15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-4.7,1.3 -4.7,3 15.9,16.6 16.7,15.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 1.1,
    className: "st1",
    width: 15.2,
    height: 8.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "27.7,1.1 31.9,1.1 31.9,3.6 11.5,17 6.6,15  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31.9,1.3 31.9,3 11.3,16.6 10.5,15.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 17.4,
    className: "st1",
    width: 15.2,
    height: 8.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "27.7,25.5 31.9,25.5 31.9,23 11.5,9.6 6.6,11.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31.9,25.3 31.9,23.6 11.3,10 10.5,11.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -4.7,
    y: 17.4,
    className: "st1",
    width: 15.2,
    height: 8.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-0.5,25.5 -4.7,25.5 -4.7,23 15.6,9.6 20.6,11.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-4.7,25.3 -4.7,23.6 15.9,10 16.7,11.2  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.9,9.2 16.7,9.2 16.7,1.1 10.4,1.1 10.4,9.2 -4.7,9.2 -4.7,17.2 10.4,17.2 10.4,25.5 16.7,25.5  16.7,17.2 31.9,17.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31.9,10.8 15.4,10.8 15.4,1.1 11.7,1.1 11.7,10.8 -4.7,10.8 -4.7,15.6 11.7,15.6 11.7,25.5  15.4,25.5 15.4,15.6 31.9,15.6  "
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 13.5,
    cy: 13.5,
    r: 11.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEn);
export default __webpack_public_path__ + "static/media/lang-en.4d793175680f95086e290d27768dbe1c.svg";
export { ForwardRef as ReactComponent };